import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular-ivy';

if (environment.production) {
  enableProdMode();
  // Disable logs
  if (window) {
    window['log'] = window.console.log;
    window['info'] = window.console.info;
    window['debug'] = window.console.debug;
  }
  
  window.console.log = () => { }
  window.console.warn = () => { }
  window.console.info = () => { }
  window.console.debug = () => { }
}

Sentry.init({
  dsn: "https://cfd287c24e4bea8b9deacedfbb81f57c@sentry.sparrks.io/8",
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/api.sparrks.io/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: environment.environmentName,
  enabled: environment.sentryEnabled
})

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
